import React, { useState, useEffect, useCallback } from 'react';
import { adminGetAuditLogs, adminGetTenants } from '../../api';
import SearchSelect from '../SearchSelect';

const PAGE_SIZE = 50;

const ACTION_LABELS = {
  'auth.login': 'Connexion',
  'auth.login_failed': 'Connexion échouée',
  'auth.logout': 'Déconnexion',
  'auth.password_change': 'Changement de mot de passe',
  'client.create': 'Création client',
  'client.update': 'Modification client',
  'client.delete': 'Suppression client',
  'article.create': 'Création article',
  'article.update': 'Modification article',
  'devis.create': 'Création devis',
  'devis.update': 'Modification devis',
  'facture.create': 'Création facture',
  'facture.update': 'Modification facture',
  'entreprise.update': 'Modification entreprise',
  'entreprise.logo_upload': 'Upload logo',
  'admin.tenant.create': 'Création tenant',
  'admin.tenant.suspend': 'Suspension tenant',
  'admin.tenant.reactivate': 'Réactivation tenant',
  'admin.tenant.reset_password': 'Réinitialisation mdp',
};

function formatDetails(details) {
  if (!details) return '';
  try {
    const d = JSON.parse(details);
    return Object.entries(d).map(([k, v]) => `${k}: ${v}`).join(' · ');
  } catch {
    return details;
  }
}

function AdminAuditLog() {
  const [logs, setLogs] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [tenantFilter, setTenantFilter] = useState('');
  const [page, setPage] = useState(0);

  useEffect(() => {
    adminGetTenants().then(res => setTenants(res.data)).catch(() => {});
  }, []);

  const loadLogs = useCallback(async () => {
    try {
      const params = { limit: PAGE_SIZE, offset: page * PAGE_SIZE };
      if (tenantFilter) params.tenant_id = tenantFilter;
      const res = await adminGetAuditLogs(params);
      setLogs(res.data);
    } catch {
      setLogs([]);
    }
  }, [page, tenantFilter]);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Journal d'audit</h2>
        <div style={{ minWidth: '280px' }}>
          <SearchSelect
            placeholder="Filtrer par tenant..."
            options={tenants.map(t => ({ value: t.id, label: t.nom }))}
            value={tenantFilter}
            onChange={(val) => { setTenantFilter(val); setPage(0); }}
          />
        </div>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Tenant</th>
              <th>Utilisateur</th>
              <th>Action</th>
              <th>Détails</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr><td colSpan="5" style={{ textAlign: 'center' }}>Aucune entrée</td></tr>
            ) : (
              logs.map(l => (
                <tr key={l.id}>
                  <td className="num">{new Date(l.created_at + 'Z').toLocaleString('fr-FR')}</td>
                  <td>{l.tenant_nom || '—'}</td>
                  <td>{l.user_email || '—'}</td>
                  <td>{ACTION_LABELS[l.action] || l.action}</td>
                  <td style={{ maxWidth: '320px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {formatDetails(l.details)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="actions" style={{ justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>
            ← Précédent
          </button>
          <button className="btn btn-secondary btn-sm" disabled={logs.length < PAGE_SIZE} onClick={() => setPage(p => p + 1)}>
            Suivant →
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminAuditLog;
